<template>
<a href="https://taiyakan-gotemba.com/">
  <div class="hello">
    <h1>{{ msg }}</h1>
    <img class="img_taiyakan" alt="time" src="../assets/taiyakan_mockup.webp">
    <h2 class="taiyakan_h2">ホームページ × 混雑状況システム</h2>
    <p class="taiyakan_p">
      インスタグラムの投稿をもとに、Webサイトをアップデートします。<br>
      待ち時間を表示するシステムを
      店舗に設置しています。
    </p>
  </div>
</a>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello{
  margin-bottom: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.img_taiyakan {
  border-radius: 20px;
  width: 80%;
  mix-blend-mode: multiply;
}
.taiyakan_p{
  font-size: 13px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  padding-left: 25%;
  padding-right: 25%;
}
.taiyakan_h2{
  font-size: 0.9rem;
}
a{
  text-decoration: none;
  color: #2c3e50;
}
</style>
